import type { useJsApiLoader } from "@react-google-maps/api";

/**
 * Opciones de carga de Google Maps (`useJsApiLoader`), una sola vez para toda la app. Viven en su propio módulo para
 * que `libraries` sea siempre el mismo arreglo: si cambia (otro componente con su propio arreglo, o el hot reload de un
 * componente que lo declara), `@react-google-maps/api` recarga el script y avisa "LoadScript has been reloaded
 * unintentionally". Todos los componentes que cargan Google deben usar estas opciones.
 */
export const GOOGLE_MAPS_LOADER_OPTIONS: Parameters<typeof useJsApiLoader>[0] = {
  googleMapsApiKey: String(import.meta.env.VITE_GOOGLE_MAPS_API_KEY || ""),
  libraries: ["places"],
  version: "weekly",
  language: "es",
  region: "MX",
};
